
import { useState, useEffect, useCallback } from "react";
import { VideoItem } from "@/types/video";
import { supabase } from "@/integrations/supabase/client";
import { Database } from "@/integrations/supabase/types";

// Τύπος για τα δεδομένα του πίνακα videos
type VideoRow = Database['public']['Tables']['videos']['Row'];

export function useVideos() {
  const [videos, setVideos] = useState<VideoItem[]>([]);
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Function to load videos from Supabase
  const loadVideos = useCallback(async () => {
    setIsLoading(true);
    
    try {
      console.log("Fetching videos from Supabase...");
      const { data, error } = await supabase
        .from('videos')
        .select('*')
        .order('id');
      
      if (error) {
        console.error("Error fetching videos:", error);
        throw error;
      }
      
      console.log("Videos fetched successfully:", data);
      
      // Convert the Supabase data to VideoItem format
      const videoItems: VideoItem[] = (data as VideoRow[]).map(item => ({
        id: item.id,
        title: item.title,
        duration: item.duration,
        credits: item.credits,
        isPremiere: item.is_premiere,
        url: item.url || undefined,
        category: item.category || undefined,
        thumbnailUrl: item.thumbnail_url || undefined
      }));
      
      setVideos(videoItems);
      return videoItems;
    } catch (error) {
      console.error("Error in loadVideos:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Initialize videos on mount
  useEffect(() => {
    if (!isInitialized) {
      console.log("Initializing useVideos hook");
      loadVideos();
      setIsInitialized(true);
    }
  }, [loadVideos, isInitialized]);

  // Add method to forcefully refresh videos from storage
  const refreshVideos = useCallback(async () => {
    console.log("Forcing video refresh");
    return loadVideos();
  }, [loadVideos]);

  return { videos, refreshVideos, isLoading };
}
